import * as React from 'react'

import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'
import { UniqueTimeBlockData } from 'modules/attendance/store/models/UniqueTimeBlockData'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

interface Props {
  timeSettingsCategoryById: Record<number, CustomTimeRangeCategory[]>
  timeBlockData: UniqueTimeBlockData
  isLast: boolean
  onSelectTimeBlock: (timeBlock: UniqueTimeBlockData, checked: boolean) => void
}

const CheckBoxItem = ({
  timeSettingsCategoryById,
  timeBlockData,
  isLast,
  onSelectTimeBlock,
}: Props) => {
  const [toggleCheck, setToggleCheck] = React.useState(false)

  const overtimeFromBalanceStr = i18n.t(
    'clock_in.sidepanel.compensation.modal.time_blocks.overtime_from_balance'
  )
  const name = timeBlockData.name
    ? timeBlockData.name
    : timeBlockData.timeSettingsCustomTimeRangeCategoryId
      ? timeSettingsCategoryById[timeBlockData.timeSettingsCustomTimeRangeCategoryId]?.[0]?.name ||
        overtimeFromBalanceStr
      : overtimeFromBalanceStr

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      paddingY="s16"
      paddingX="s24"
      border={
        isLast
          ? false
          : {
              bottom: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }
      }
    >
      <Box flexDirection="row" gap="s16">
        <Checkbox
          checked={toggleCheck}
          size="large"
          onChange={() => {
            setToggleCheck(!toggleCheck)
            onSelectTimeBlock(timeBlockData, !toggleCheck)
          }}
        />
        <Box>
          <Text.Normal weight="medium" color="grey1000">
            {name}
          </Text.Normal>
          <Text.Normal>
            {i18n.t('clock_in.sidepanel.compensation.modal.time_blocks.hour_value')}
          </Text.Normal>
        </Box>
      </Box>

      <Box alignItems="flexEnd">
        <MinutesToText value={timeBlockData.minutes} color="grey1000" weight="medium" />

        <Box flexDirection="row">
          <MinutesToText value={timeBlockData.rawMinutes} />
          <Text.Normal>=</Text.Normal>
          <MinutesToText value={timeBlockData.equivalentMinutes} />
        </Box>
      </Box>
    </Box>
  )
}

export default CheckBoxItem
